/* eslint-disable @typescript-eslint/no-explicit-any */

import { useMemo } from "react";

export const FeedbackFormConfig = (translations: (arg0: string) => any) => {
  return useMemo(() => {
    const t = (key: string) => translations(key);
    const formConfig = {
      id: "login-form",
      fields: [
        {
          name: "feedback",
          label: t("feedback.content.feedback"),
          placeholder: t("feedback.content.feedbackPlaceholder"),
          type: "text-area",
        },
      ],
      onSubmit: (data: Record<string, any>) => {
        console.log("Form submitted:", data);
      },
    };
    return formConfig;
  }, [translations]);
};
